// extracted by mini-css-extract-plugin
export default {"container":"folders_dropdown_create_text-module__container--12H5k"};